module.exports = __webpack_public_path__ + "img/product-shot_02.ce8e9484.jpg";